import React from "react";
import { LinkedIn, GitHub } from "@material-ui/icons";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://linkedin.com" target="_blank">
        <LinkedIn />
      </a>
      <a href="https://github.com" target="_blank">
        <GitHub />
      </a>
      {/* <a href="https://linkedin.com" target="_blank"></a> */}
    </div>
  );
};

export default HeaderSocials;
